import React, { useRef } from "react";
import "./Join.css";
import emailjs from '@emailjs/browser'

const Join = () => {
    const form = useRef()

const sendEmail = (e) => {
    e.preventDefault();
    alert('this is a demo project, functionality intentionally has been turned off for this button')
    // emailjs.sendForm()
    // .then((result)=> {
    //     console.log(result.text);
    // }, (error) => {
    //         console.log(error.text);
    // })
}




  return (
    <div className="join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span className="stroke-text">Ready to</span>
          <span>level up</span>
        </div>
        <div>
          <span>your body</span>
          <span className="stroke-text">with us?</span>
        </div>
      </div>
      <div className="right-j">
        <form onSubmit={sendEmail} ref={form} className="email-container" action="">
            <input type="email" name='user_email' placeholder="enter your email here"/>
            <button className="btn btn-j">Join Now</button>
        </form>
      </div>
    </div>
  );
};

export default Join;
